export default __webpack_public_path__ + "static/media/np_discount.e1a81eaa.svg";